<template>
  <SfDataPlaceholder>
    {{ $t('Musisz najpierw wybrać opcję dostawy.') }}
  </SfDataPlaceholder>
</template>
